import { EmptyState, Button } from '@arqam/ui'
import { CloudOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'

/** Shown when the API does not answer: an outage, not a reason to sign the user out. */
export function Unavailable({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation()
  return (
    <EmptyState
      headingLevel={1}
      title={t('unavailable.title')}
      description={t('unavailable.description')}
      icon={<CloudOff size={32} />}
      action={<Button onClick={onRetry}>{t('unavailable.retry')}</Button>}
    />
  )
}
